import { render, staticRenderFns } from "./LoadingContainer.vue?vue&type=template&id=536230b6&scoped=true"
import script from "./LoadingContainer.vue?vue&type=script&lang=js"
export * from "./LoadingContainer.vue?vue&type=script&lang=js"
import style0 from "./LoadingContainer.vue?vue&type=style&index=0&id=536230b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536230b6",
  null
  
)

export default component.exports